import { ApiResultQuoteShare, IQuotationContactPreference, IQuotationLog } from './../Types/CategoryQuotation/Api';
import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { stringify } from 'qs'
import { ApiCategoryQuotationRequest, ApiResult, ApiCategoryQuotationPhone, ApiCategoryQuotationVerification, ApiQuotationLead } from 'Types'
import { ApiQuoteReadOnlyCompanyInfo, ApiQuoteReadOnlyDetail, ApiQuoteReadOnlyHistoryChat } from 'Types/QuoteReadOnly/Api';

const endpoint = `${apiUrl.stable}/cotacoes`

export const getQuestions = (serviceTypeId: number, addressId: number) => {
  const url = `${endpoint}/formulario`

  const params = { serviceTypeId, addressId }

  return axios.get(url, { params })
}

export const getAddressList = () => {
  const url = `${endpoint}/enderecos`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getSponsorship = (categoryId: number, serviceTypeId: number) => {
  const url = `${endpoint}/financiamento`

  const params = { categoryId, serviceTypeId }

  return axios.get(url, { params })
}

export const getCrossOptions = (serviceTypeId: number) => {
  const url = `${endpoint}/cross/opcoes`

  const params = { serviceTypeId }

  return axios.get(url, { params })
}

/** Send a new quotation request for the logged user */
export const sendQuotation = (data: ApiCategoryQuotationRequest) => {
  const url = `${endpoint}/solicitar`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

export const getCompanyInfo = (ids) => {
  const url = `${endpoint}/empresas/obtem`

  const headers = { ...jsonWebToken.header }
  const params = { ids }
  const paramsSerializer = params => stringify(params, { arrayFormat: 'repeat' })

  return axios.get(url, { headers, params, paramsSerializer })
}

export const getQuotationPhone = (): ApiResult<ApiCategoryQuotationPhone> => {
  const url = `${endpoint}/contatos`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const checkDuplicatedQuotation = (serviceId: number, addressId: number): ApiResult<ApiCategoryQuotationVerification> => {
  const url = `${endpoint}/solicitacoes/verificar-duplicidade`

  const headers = { ...jsonWebToken.header }

  const params = {
    ServiceTypeId: serviceId,
    AddressId: addressId,
  }

  return axios.get(url, { headers, params })
}

// #region ReadOnly
export const generateReadOnly = (data): ApiResult<ApiResultQuoteShare> => {
  const url = `${endpoint}/compartilhar/gerar`

  const headers = {
    ...jsonWebToken.header,
    'Content-Type': 'application/json;charset=utf-8'

  }

  return axios.post(url, data.toString(), { headers })
}


export const generateNewReadOnly = (data): ApiResult<ApiResultQuoteShare> => {
  const url = `${endpoint}/compartilhar/atualizar`

  const headers = {
    ...jsonWebToken.header,
    'Content-Type': 'application/json;charset=utf-8'

  }

  return axios.post(url, data.toString(), { headers })
}

export const getChathistory = (id, companyId): ApiResult<ApiQuoteReadOnlyHistoryChat[]> => {
  const url = `${endpoint}/compartilhar/${id}/chat/${companyId}`

  return axios.get(url)
}

export const getCompanyChatInfo = (id, companyId): ApiResult<ApiQuoteReadOnlyCompanyInfo> => {
  const url = `${endpoint}/compartilhar/${id}/company/${companyId}`

  return axios.get(url)
}
// endregion

export const sendQuotationLead = (data: ApiQuotationLead) => {
  const url = `${endpoint}/leads/registrar`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

export const getCrossQuotationById = (id): ApiResult<ApiQuoteReadOnlyDetail> => {
  const url = `${endpoint}/compartilhar/${id}`

  return axios.get(url)
}

export const getContactPreference = (): ApiResult<number> => {
  const url = `${endpoint}/preferencia-contato`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}



export const sendQuotationLog = (data: IQuotationLog): ApiResult<any> => {
  const url = `${endpoint}/log/registrar`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

export default {
  getQuestions,
  getAddressList,
  getSponsorship,
  getCrossQuotationById
}